import model from "../model/model";
import { pocket } from "../pocket/pocket";

function mapSong(s){
    return {
        id: s.id,
        title: s.title || "",
        author: s.author || "",
        capo: s.capo || 0,
        sfw: s.sfw || false,
        international: s.international || false,
        genre: Array.isArray(s.genre) ? s.genre : [],
        verses: s.verses || []
    }
}

export function getCacheSongs(){
    let res = JSON.parse(localStorage.getItem("songs"))
    if (Array.isArray(res)) {
        res = res.map(song => mapSong(song))
        localStorage.setItem("songs", JSON.stringify(res))
    }
    return res;
}

export async function getSongs(){
    let res = getCacheSongs()
    
    try {
        res = await pocket.collection("song").getFullList(1000)
        res = res.map(s => mapSong(s))
        localStorage.setItem("songs",JSON.stringify(res))
    } catch (error) {
        console.log(error)
    }

    return res
}

export async function createSong(data){
    const record = await pocket.collection('song').create(data).catch(err => {
        console.log(err)
        throw(err)
    })
    await model.loadSongs()
    return record
}

export async function modifySong(id,data){
    const payload = {...data, secret:model.settings.secret}
    const record = await  pocket.collection('song').update(id, payload).catch(err => {
        console.log(err)
        throw(err)
    })
    await model.loadSongs()
    return record
}